<template>
  <div class="outlets">
    <div class="appHelmetwd">商业网点</div>
    <div class="hotb-let">
      <div class="hotb-let-nr" v-for="(wdym,index) in wdxi" :key = wdym.ID @click="table(index)" :class="num == index ? 'hotb-let-nrmr' : ''">
        <p class="hotb-let-nrbk" @click="tabsj(wdym.ID)">{{wdym.MENU_NAME}}</p>
      </div>
    </div>
    <div class="hotb-rig">
      <div class="yllb-xztp">
        <img src="../../public/obraoag/homelb.png" alt="" class="carousel-img">
      </div>
      <div class="hotb-marn" v-if="!aaaa">
        <div class="hotb-rig-nr" v-for="sbzzxca in wdzd" :key = sbzzxca.ID>
          <router-link :to="{path:'details',query:{commid: sbzzxca.ID}}">
            <div class="hotb-rig-nr-tp">
              <img :src="sbzzxca.COMPANY_SMALL_URL"  alt="">
            </div>
            <div class="hotb-rig-nr-nr">
              <p class="hotb-rig-nr-nrpa">{{sbzzxca.COMPANY_NAME}}</p>
              <p class="hotb-rig-nr-nrpb">地址: <span>{{sbzzxca.DETAILED_ADDRESS}}</span></p>
              <p class="hotb-rig-nr-nrpc">电话: <span>{{sbzzxca.PHONE}}</span></p>
              <p class="hotb-rig-nr-nrpd"><span>享会员价</span></p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="hotb-marn" v-else>
        <div class="hotb-rig-nr" v-for="sbzzxqa in sbzzxq" :key = sbzzxqa.ID>
          <router-link :to="{path:'details',query:{commid: sbzzxqa.ID}}">
            <div class="hotb-rig-nr-tp">
              <img :src="sbzzxqa.COMPANY_SMALL_URL" alt="">
            </div>
            <div class="hotb-rig-nr-nr">
              <p class="hotb-rig-nr-nrpa">{{sbzzxqa.COMPANY_NAME}}</p>
              <p class="hotb-rig-nr-nrpb">地址: <span>{{sbzzxqa.DETAILED_ADDRESS}}</span></p>
              <p class="hotb-rig-nr-nrpc">电话: <span>{{sbzzxqa.PHONE}}</span></p>
              <p class="hotb-rig-nr-nrpd"><span>享会员价</span></p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <div class="hotb-Navition">
      <router-link :to="{path: '/'}">
        <div class="hotb-Navition-content hotb-Navition-hoge">
          <img src="../../public/obraoag/HomePage.png" alt="">
          <span>首页</span>
        </div>
      </router-link>
      <div class="hotb-Navition-content hotb-Navition-cork">
        <img src="../../public/obraoag/HomeFindSelect.png" alt="">
        <span>商业网点</span>
      </div>
      <router-link :to="{path: 'PersCent'}">
        <div class="hotb-Navition-content hotb-Navition-size">
          <img src="../../public/obraoag/HomeMy.png" alt="">
          <span>我的</span>
        </div>
      </router-link>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + outelong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      wdxi: '',
      wdzd: '',
      num: 0,
      sbzzxq: '',
      aaaa: '',
      customerID: '',
      OuQuanty: '',
      outelong: 'block'
    }
  },
  created () {
    this.$axios.post('wx/point',this.$qs.stringify({}),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.outelong = 'none';
      this.wdxi = res.data.data;
      this.wdzd = res.data.details;
    })
    .catch(() => {
      console.log('获取失败');
    });
    // 通过拼接商品ID获取购物车商品信息
    // this.$axios.post('wx/add/shopcart/list',this.$qs.stringify({
    //   showCount: '10',
    //   currentPage: '1'
    // }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    // .then(res => {
    //   this.OuQuanty = res.data.page.totalResult;
    // })
    // .catch(() => {
    //   console.log('获取失败');
    // });
  },
  mounted () {

  },
  methods: {
    table(index) {
      this.num = index;
    },
    tabsj(flsj) {
      this.outelong = 'block';
      this.aaaa = flsj;
      this.$axios.post('wx/pointrighe?PARENT_ID=' + this.aaaa,this.$qs.stringify({}),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        this.outelong = 'none';
        this.sbzzxq = res.data.data;
      })
      .catch(() => {
        console.log('获取失败');
      });
    }
  }
}
</script>

<style scoped>
  @import "obraocs/outlets.css";
</style>